import React from 'react'
import {ListGroup} from 'react-bootstrap'
import {Section, TabsPolicy} from '../OnePolicyPage'

interface ListSectionSideProps {
  sections: readonly Section[]
  tabs: TabsPolicy
  setTabs: (tab: TabsPolicy) => void
  lead?: string | null
  onOpenNotes: () => void
}

export const ListSectionSide: React.FC<ListSectionSideProps> = ({
  sections,
  tabs,
  setTabs,
  lead,
  onOpenNotes,
}) => (
  <div className='list-menu '>
    <div className='kt-heading kt-heading--sm custom-border-brand my-3'>Sections</div>
    <ListGroup variant='flush'>
      {sections.map((tabl) => (
        <ListGroup.Item
          key={tabl.name}
          className='policy-sections'
          action
          variant={tabs === tabl.name ? 'primary' : 'light'}
          onClick={() => {
            if (lead && Number(lead)) return
            if (tabl.name === 'Notes') {
              onOpenNotes()
              return
            }
            setTabs(tabl.name)
          }}
        >
          {tabl.icon && (
            <i
              className={`bi bi-${tabl.icon} fs-3`}
              style={{color: 'inherit', marginRight: '8px'}}
            />
          )}
          {tabl.name}
        </ListGroup.Item>
      ))}
    </ListGroup>
  </div>
)
